var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgContactus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1730px",
    height: "671px",
    viewBox: "0 0 1730 671",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg_contactus3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg_contactus3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -129.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#172B4D",
    points: "627 0 841 0 841 214 627 214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409,137 C1468.09446,137 1516,184.905532 1516,244 L1516,351 L1302,351 L1302,244 C1302,184.905532 1349.90554,137 1409,137 Z",
    id: "Path",
    fill: "#FE5E33",
    transform: "translate(1409.000000, 244.000000) scale(-1, 1) rotate(-180.000000) translate(-1409.000000, -244.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196,0 C1255.09446,0 1303,47.9055317 1303,107 L1303,214 L1089,214 L1089,107 C1089,47.9055317 1136.90554,0 1196,0 Z",
    id: "Path",
    fill: "#FE5E33",
    transform: "translate(1196.000000, 107.000000) rotate(-180.000000) translate(-1196.000000, -107.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,0 C166.094468,0 214,47.9055317 214,107 L214,214 L107,214 C47.9055317,214 0,166.094468 0,107 C0,47.9055317 47.9055317,0 107,0 Z",
    id: "Path",
    fill: "#4E80EE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4E80EE",
    x: 731,
    y: 0,
    width: 214,
    height: 214,
    rx: 107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730,321 L1516,321 C1516,261.905532 1563.90554,214 1623,214 C1682.09446,214 1730,261.905532 1730,321 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093,215 C1093,274.922895 1044.4229,323.5 984.5,323.5 C984.5,263.577105 1033.0771,215 1093,215 Z M876,432 C876,372.077105 924.577105,323.5 984.5,323.5 C984.5,383.422895 935.922895,432 876,432 Z M984.5,323.5 C924.577105,323.5 876,274.922895 876,215 C935.922895,215 984.5,263.577105 984.5,323.5 Z M984.5,323.5 C1044.4229,323.5 1093,372.077105 1093,432 C1033.0771,432 984.5,383.422895 984.5,323.5 Z",
    id: "Shape",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FE5E33",
    points: "1302 0 1516 0 1516 214 1302 214"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4E80EE",
    points: "410 0 624 0 624 214 410 214"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FE5E33",
    points: "0 214 214 214 214 428 0 428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093,214 L1206,214 C1268.40817,214 1319,264.591823 1319,327 C1319,389.408177 1268.40817,440 1206,440 C1143.59183,440 1093,389.408177 1093,327 L1093,214 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409,510 C1365.36951,510 1330,474.406638 1330,430.5 C1330,386.593362 1365.36951,351 1409,351 L1409,510 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#4E80EE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1407.85,510.72 L1407.85,351.29 C1452.17086,351.29 1488.1,386.979621 1488.1,431.005 C1488.1,475.030379 1452.17086,510.72 1407.85,510.72 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.55,214 L622.55,-1.42108547e-14 C681.644468,-1.42108547e-14 729.55,47.9055317 729.55,107 C729.55,166.094468 681.644468,214 622.55,214 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.83,214 L305.83,0 C364.924468,0 412.83,47.9055318 412.83,107 C412.83,166.094468 364.924468,214 305.83,214 Z",
    id: "Path",
    transform: "translate(359.330000, 107.000000) rotate(-180.000000) translate(-359.330000, -107.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 428,
    width: 211,
    height: 211,
    rx: 105.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516,321 L1730,321 C1730,380.094468 1682.09446,428 1623,428 C1563.90554,428 1516,380.094468 1516,321 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214,214 C214,154.905532 261.905532,107 321,107 C321,166.094468 273.094468,214 214,214 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114,108 C1114,167.094468 1066.09447,215 1007,215 C1007,155.905532 1054.90553,108 1114,108 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623,214 C1623,273.094468 1575.09446,321 1516,321 C1516,261.905532 1563.90554,214 1623,214 Z",
    id: "Path",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,428 L213,214 C272.094468,214 320,261.905532 320,321 C320,380.094468 272.094468,428 213,428 Z",
    id: "Path",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,351 C34,291.905532 81.9055317,244 141,244 C141,303.094468 93.0944683,351 34,351 Z",
    id: "Path",
    fill: "#172B4D",
    transform: "translate(87.500000, 297.500000) scale(-1, 1) translate(-87.500000, -297.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.02402,543.506273 C829.95896,559.494423 807.408456,570.251194 781.580498,570.251194 C755.752541,570.251194 733.202037,559.494423 721.136977,543.506273 C733.202037,527.518123 755.752541,516.761352 781.580498,516.761352 C807.408456,516.761352 829.95896,527.518123 842.02402,543.506273 Z",
    id: "Path",
    fill: "#172B4D",
    transform: "translate(781.580498, 543.506273) scale(-1, 1) rotate(50.000000) translate(-781.580498, -543.506273) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.02402,544.506273 C1184.95896,560.494423 1162.40846,571.251194 1136.5805,571.251194 C1110.75254,571.251194 1088.20204,560.494423 1076.13698,544.506273 C1088.20204,528.518123 1110.75254,517.761352 1136.5805,517.761352 C1162.40846,517.761352 1184.95896,528.518123 1197.02402,544.506273 Z",
    id: "Path-Copy",
    fill: "#172B4D",
    transform: "translate(1136.580498, 544.506273) rotate(50.000000) translate(-1136.580498, -544.506273) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.5,633 C1640.89784,617.729926 1623,589.189007 1623,556.5 C1623,523.810993 1640.89784,495.270074 1667.5,480 C1694.10216,495.270074 1712,523.810993 1712,556.5 C1712,589.189007 1694.10216,617.729926 1667.5,633 Z M1578.5,633 C1551.89784,617.729926 1534,589.189007 1534,556.5 C1534,523.810993 1551.89784,495.270074 1578.5,480 C1605.10216,495.270074 1623,523.810993 1623,556.5 C1623,589.189007 1605.10216,617.729926 1578.5,633 Z",
    id: "Shape",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FE5E33",
    x: 524,
    y: 214,
    width: 214,
    height: 214,
    rx: 107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,480 C134.271091,480 158,503.728909 158,533 C158,562.271091 134.271091,586 105,586 C75.7289082,586 52,562.271091 52,533 C52,503.728909 75.7289082,480 105,480 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,443 C651.434536,443 668,459.565464 668,480 C668,500.434536 651.434536,517 631,517 C610.565464,517 594,500.434536 594,480 C594,459.565464 610.565464,443 631,443 Z",
    id: "Path",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983,291 C1000.67311,291 1015,305.326889 1015,323 C1015,340.673111 1000.67311,355 983,355 C965.326891,355 951,340.673111 951,323 C951,305.326889 965.326891,291 983,291 Z",
    id: "Path",
    fill: "#4E80EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.5,287 C843.315248,287 861,304.684752 861,326.5 C861,348.315248 843.315248,366 821.5,366 C799.684752,366 782,348.315248 782,326.5 C782,304.684752 799.684752,287 821.5,287 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.5,512 C1647.07667,512 1667,531.699471 1667,556 C1667,580.300529 1647.07667,600 1622.5,600 C1597.92333,600 1578,580.300529 1578,556 C1578,531.699471 1597.92333,512 1622.5,512 Z",
    id: "Path",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5,53 C476.047234,53 500,76.9527659 500,106.5 C500,136.047234 476.047234,160 446.5,160 C416.952766,160 393,136.047234 393,106.5 C393,76.9527659 416.952766,53 446.5,53 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.5,53 C862.047234,53 886,76.9527659 886,106.5 C886,136.047234 862.047234,160 832.5,160 C802.952766,160 779,136.047234 779,106.5 C779,76.9527659 802.952766,53 832.5,53 Z",
    id: "Path",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516,22 C1516,81.3884706 1467.85613,129.532338 1408.46766,129.532338 C1408.46766,70.1438677 1456.61153,22 1516,22 Z M1302,236 C1302,176.611529 1350.14387,128.467662 1409.53234,128.467662 C1409.53234,187.856132 1361.38847,236 1302,236 Z M1409.53234,129.532338 C1350.14387,129.532338 1302,81.3884706 1302,22 C1361.38847,22 1409.53234,70.1438677 1409.53234,129.532338 Z M1408.46766,128.467662 C1467.85613,128.467662 1516,176.611529 1516,236 C1456.61153,236 1408.46766,187.856132 1408.46766,128.467662 Z",
    id: "Shape",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623,0 L1730,0 L1730,214 L1623,214 C1563.90554,214 1516,166.094468 1516,107 C1516,47.9055317 1563.90554,0 1623,0 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.5,76 C1653.04724,76 1677,99.9527659 1677,129.5 C1677,159.047234 1653.04724,183 1623.5,183 C1593.95276,183 1570,159.047234 1570,129.5 C1570,99.9527659 1593.95276,76 1623.5,76 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,428 C412,486.266041 364.766041,533.5 306.5,533.5 C306.5,475.233959 353.733959,428 412,428 Z M201,639 C201,580.733959 248.233959,533.5 306.5,533.5 C306.5,591.766041 259.266041,639 201,639 Z M306.5,533.5 C248.233959,533.5 201,486.266041 201,428 C259.266041,428 306.5,475.233959 306.5,533.5 Z M306.5,533.5 C364.766041,533.5 412,580.733959 412,639 C353.733959,639 306.5,591.766041 306.5,533.5 Z",
    id: "Shape",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,215 L524,215 L524,317 C524,373.333044 478.333044,419 422,419 C365.666956,419 320,373.333044 320,317 C320,260.666956 365.666956,215 422,215 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738,321 C738,380.094468 690.094468,428 631,428 C631,368.905532 678.905532,321 738,321 Z M631,428 C571.905532,428 524,380.094468 524,321 C583.094468,321 631,368.905532 631,428 Z",
    id: "Shape",
    fill: "#172B4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgContactus3);
export default __webpack_public_path__ + "static/media/bg_contactus3.a17e8c4ada4d80afcf898c573b509110.svg";
export { ForwardRef as ReactComponent };